import React, { useState } from 'react'
import { SortOrder } from '../components/ui/materialui/serverSideTable'
import { AxiosResponse } from 'axios'
import axiosInstance from '../interceptors/axiosInstance'
import { StatusCode } from '../utils/enums'



export const useDataFetch = (
  initialUrl: string,
  paramsProps?: URLSearchParams,
  esMensajeApi?: boolean,
) => {
  const [toggleCleared, setToggleCleared] = React.useState(false)
  const [data, setData] = useState<any>([])
  const [loading, setLoading] = useState(false)
  const [totalRows, setTotalRows] = useState(0)
  const [perPage, setPerPage] = useState(10)
  const [page, setPage] = useState(0)
  const [params, setParams] = useState(paramsProps ?? new URLSearchParams())
  const [order, setOrder] = React.useState<SortOrder>('asc');
  const [esError, setEsError] = useState(false)
  const [esExportAll, setEsExportAll] = useState(false)
  let url = initialUrl

  async function getData(url: string) {
    // deuda tecnica: el flag esExportAll es solo para que cuando se ocupe fetchAll
    // la pantalla no cargue de nuevo.
    if (!esExportAll) {
      try {
        const response: AxiosResponse = await axiosInstance.get(url);

        const dataJson = await response.data
        if (response.status === StatusCode.Ok) {
          if (esMensajeApi) {
            setData(dataJson.resultados)
            setTotalRows(dataJson.paginado.total ?? 0)
          } else {
            setData(dataJson.results)
            setTotalRows(dataJson.paging.total ?? 0)
          }
        } else {
          setData([])
          setTotalRows(0)
          setEsError(true)
        }
      } catch (error) {
        console.error('Error en la request:', error)
        setData([])
        setTotalRows(0)
        setEsError(true)
      } finally {
        setLoading(false)
      }
    }
  }

  const manejarCambiosFiltros = (filtro: string, valor?: string) => {
    if (valor) {
      let paramsData = params
      paramsData.delete(filtro)
      paramsData.append(filtro, valor)
      setParams(paramsData)
    } else {
      params.delete(filtro)
    }
  }

  const fetchData = async (pageParam?: number) => {

    setLoading(true)

    let skip = 0

    if (pageParam) {
      setPage(pageParam)
      skip = perPage * (pageParam - 0)
    } else {
      setPage(0);
      skip = 0;
    }

    params.delete('skip')
    params.append('skip', skip.toString())

    params.delete('take')
    params.append('take', perPage.toString())

    if (params.toString() && !url.includes('?')) {
      url += '?' + params.toString()
    }

    await getData(url)
  }

  const fetchAll = async () => {
    setEsExportAll(true)
    var paramsFetch = params

    const skip = params.get('skip')

    const take = params.get('take')

    paramsFetch.delete('skip')
    paramsFetch.append('skip', '0')

    paramsFetch.delete('take')
    paramsFetch.append('take', totalRows.toString())

    if (paramsFetch.toString() && !url.includes('?')) {
      url += '?' + paramsFetch.toString()
    }

    paramsFetch.append('skip', skip!)

    paramsFetch.append('take', take!)

    const response: AxiosResponse = await axiosInstance.get(url);

    setEsExportAll(false)

    await response.data
  }

  return {
    manejarCambiosFiltros,
    fetchData,
    data,
    loading,
    totalRows,
    perPage,
    page,
    params,
    getData,
    setLoading,
    setPage,
    setPerPage,
    fetchAll,
    toggleCleared,
    setToggleCleared,
    order,
    setOrder,
    esError,
  }
}
